/** Table markers that expand into products / services tables (not simple value substitution). */
export const TEMPLATE_TABLE_MARKERS = ['specification', 'products', 'additionals'] as const;

export type TemplateTableMarker = (typeof TEMPLATE_TABLE_MARKERS)[number];

export const TEMPLATE_MARKER_REGEX = /\{(specification|products|additionals)\}/gi;

const MARKER_NAME_SET = new Set<string>(TEMPLATE_TABLE_MARKERS);

const stripMarkerNoise = (raw: string): string =>
    String(raw || '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&#8203;/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .trim()
        .toLowerCase();

/** Normalize Quill/HTML-broken `{spec<strong>ification</strong>}` → `{specification}`. */
export const normalizeTemplateMarkers = (html: string): string =>
    String(html || '').replace(/\{([^{}]+)\}/g, (full, inner: string) => {
        const cleaned = stripMarkerNoise(inner);
        return MARKER_NAME_SET.has(cleaned) ? `{${cleaned}}` : full;
    });

export const hasTemplateTableMarker = (html: string): boolean =>
    /\{(specification|products|additionals)\}/i.test(normalizeTemplateMarkers(html));
